
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 13a3 3 0 100-6 3 3 0 000 6z","stroke":"#232323","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18.173 13.917l-1.958-3.303L19 7.512l-1.507-2.598-3.857.038L12.336 1H9.323L7.43 4.34l-4.096-.855-1.507 2.598L3.79 9.391 1 12.488l1.507 2.598 3.857-.038L7.664 19h3.013l1.899-3.34 4.09.855 1.507-2.598z","stroke":"#232323","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    